import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目選項",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "性別",
    isNumber: true,
  },
];

const groupOrders = {
  年齡分層: {
    "<65": 0,
    "65-69": 1,
    "70-74": 2,
    "75-79": 3,
    "80-84": 4,
    ">=85": 5,
  },
};

export const DiseaseStatistic = {
  label: "疾病統計",
  key: "DiseaseStatistic",
  path: "Diabetes/DiseaseStatistic",
  api: "TCS_V_ChronicDiseaseV",
  render: (options) => <Diagram.Diabetes.DiseaseStatistic {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "年齡分層",
      field: "年齡分層",
      header: "",
    },
  ],
  groupOrders,
  filterColumns: [{ key: "性別", type: "string" }],
  levelColumns,
  columns: [],
};
